var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"highlighted-description"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',[_c('span',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }